import { Component } from '@angular/core';

@Component({
  selector: 'pdf-password-dialog',
  templateUrl: './pdf-password-dialog.component.html',
})
export class PdfPasswordDialogComponent {}
